/* Product-detail motion only. The native wish-list component owns saved items. */
(() => {
  'use strict';
  if (window.__nsWishlistFlightBound) return;
  window.__nsWishlistFlightBound = true;

  const selector = '[data-ns-product] [data-ns-wishlist-flight]';
  const running = new WeakMap();
  const queued = new WeakMap();
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function savedState(button) {
    try {
      const handles = JSON.parse(localStorage.getItem('wishlistItem') || '[]');
      if (Array.isArray(handles)) return handles.includes(button.dataset.wishlistHandle);
    } catch (_) {}
    return button.classList.contains('wishlist-added');
  }

  function sync(button) {
    const saved = savedState(button);
    button.dataset.nsWishlistSaved = String(saved);
    button.setAttribute('aria-pressed', String(saved));
    const label = button.querySelector('.ns-wishlist-flight-label');
    if (label) {
      if (!button.dataset.nsWishlistOriginalLabel) button.dataset.nsWishlistOriginalLabel = label.textContent;
      label.textContent = saved ? (window.wishlist?.added || button.dataset.nsWishlistOriginalLabel) : button.dataset.nsWishlistOriginalLabel;
    }
    return saved;
  }

  function syncAll() {
    document.querySelectorAll(selector).forEach(sync);
  }

  function visibleRect(node) {
    if (!node?.isConnected) return null;
    const rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0 && rect.left < innerWidth && rect.top < innerHeight ? rect : null;
  }

  function headerHeart() {
    for (const link of document.querySelectorAll('#header-component a.header-wishlist, .header-mobile a.header-wishlist')) {
      const node = link.querySelector('svg') || link;
      if (visibleRect(node)) return node;
    }
    return null;
  }

  function cancel(button) {
    const previous = running.get(button);
    if (!previous) return;
    running.delete(button);
    clearTimeout(previous.timer);
    previous.animations.forEach(animation => animation.cancel());
    previous.ghost?.remove();
  }

  function play(button, saved) {
    cancel(button);
    if (reduced()) return;
    const icon = button.querySelector('.ns-wishlist-flight-icon');
    if (!icon || typeof icon.animate !== 'function') return;
    const record = { animations: [], ghost: null, timer: null };
    running.set(button, record);
    record.animations.push(icon.animate([
      { transform: 'scale(1)' },
      { transform: saved ? 'scale(.82)' : 'scale(.75)', offset: .28 },
      { transform: 'scale(1.12)', offset: .65 },
      { transform: 'scale(1)' }
    ], { duration: 340, easing: 'cubic-bezier(.2,.75,.25,1)' }));

    const target = headerHeart();
    const sourceRect = visibleRect(icon);
    const targetRect = target && visibleRect(target);
    const filled = button.querySelector('.ns-wishlist-flight-fill');
    if (!sourceRect || !targetRect || !filled) {
      record.timer = setTimeout(() => cancel(button), 400);
      return;
    }

    const ghost = document.createElement('span');
    ghost.className = 'ns-wishlist-flight-particle';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.color = getComputedStyle(button).getPropertyValue('--ns-wishlist-gold').trim() || '#a47d35';
    ghost.appendChild(filled.cloneNode(true));
    document.body.appendChild(ghost);
    record.ghost = ghost;

    const size = 20;
    const source = { x: sourceRect.left + (sourceRect.width - size) / 2, y: sourceRect.top + (sourceRect.height - size) / 2 };
    const destination = { x: targetRect.left + (targetRect.width - size) / 2, y: targetRect.top + (targetRect.height - size) / 2 };
    const a = saved ? source : destination;
    const b = saved ? destination : source;
    const bend = Math.min(42, Math.abs(b.x - a.x) * .2);
    const middle = { x: (a.x + b.x) / 2 + bend, y: Math.max(0, (a.y + b.y) / 2 - 36) };
    const transform = (point, scale, rotation) => 'translate3d(' + point.x + 'px,' + point.y + 'px,0) scale(' + scale + ') rotate(' + rotation + 'deg)';
    const flight = ghost.animate([
      { transform: transform(a, 1, 0), opacity: .9 },
      { transform: transform(middle, 1.2, saved ? 12 : -12), opacity: 1, offset: .5 },
      { transform: transform(b, saved ? .45 : .15, 0), opacity: 0 }
    ], { duration: saved ? 680 : 590, easing: 'cubic-bezier(.3,.15,.2,1)' });
    record.animations.push(flight);
    flight.onfinish = () => {
      ghost.remove();
      if (running.get(button) !== record || reduced()) return;
      if (saved && savedState(button) && target.isConnected && typeof target.animate === 'function') {
        record.animations.push(target.animate([
          { transform: 'scale(1)' },
          { transform: 'scale(1.22)', offset: .4 },
          { transform: 'scale(1)' }
        ], { duration: 250, easing: 'ease-out' }));
      }
    };
    record.timer = setTimeout(() => cancel(button), 1050);
  }

  // Capture before the native click handler, then wait for its synchronous
  // saved-item update. Never prevent or replace the original wishlist action.
  document.addEventListener('click', event => {
    const button = event.target.closest(selector);
    if (!button || button.disabled) return;
    const before = savedState(button);
    clearTimeout(queued.get(button));
    queued.set(button, setTimeout(() => {
      queued.delete(button);
      if (!button.isConnected) return;
      const after = sync(button);
      if (after !== before) play(button, after);
    }, 0));
  }, true);

  document.addEventListener('update:wishlist-mail', () => setTimeout(syncAll, 0));
  document.addEventListener('shopify:section:load', syncAll);
  window.addEventListener('storage', event => {
    if (event.key === 'wishlistItem' || event.key === null) syncAll();
  });
  function init() {
    syncAll();
    const content = document.getElementById('MainContent');
    if (!content || typeof MutationObserver !== 'function') return;
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') {
          if (record.target.matches(selector)) sync(record.target);
        } else {
          for (const node of record.addedNodes) {
            if (node.nodeType !== 1) continue;
            if (node.matches(selector)) sync(node);
            node.querySelectorAll(selector).forEach(sync);
          }
        }
      }
    });
    observer.observe(content, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

